export default __webpack_public_path__ + "static/media/DAIF_Data_Clean.2e1fcf98.jpg";